import { createFileRoute } from "@tanstack/react-router"
import { SearchValue } from "../../-components/infinit-scrolling-table/extended-infinit-scrolling-table"
import { lazyImportRouteComponent } from "../../../../utils/lazyImportRouteComponent"

export const Route = createFileRoute(
  "/app/admin-settings/automatic-background-jobs/table"
)({
  component: lazyImportRouteComponent(
    () => import("./-components/AutomaticBackgroundJobTablePage"),
    "AutomaticBackgroundJobTablePage"
  ),
  beforeLoad: () => ({ getTitle: () => "Logs" }),
  validateSearch: (search: SearchValue<"/api/Log/GetJobLogTable">) => search,
})
